module.exports = __webpack_public_path__ + "static/media/bg.356183f3.webp";